export const SKILLS = [
    ['PHP', 'JavaScript', 'Java', 'MySQL', 'NoSQL', 'Package Management', 'Continuous Integration and Delivery', 'Version Control'],
    ['Usability Testing (Remote and Local)', 'Section 508 Compliance', 'WCAG 2.0', 'Accessibility Testing', 'Bootstrap', 'Material Design', 'jQuery'],
    ['Agile and Waterfall SDLC', 'UML Diagrams', 'Microsoft Visio', 'Remote Teamwork', 'Communication', 'Time Management', 'Technical Aptitude', 'Microsoft Project', 'Cost Management' ],
    ['Statistics', 'R', 'Excel', 'Tableau', 'Data Extraction (APIs, CSV, JSON, etc.)', 'Clustering', 'Classification'],
    ['Decision Trees', 'Neural Networks', 'Reinforcement Algorithms', 'Q-learning']
];


// WEBPACK FOOTER //
// ./src/components/Skills/constants.js